import React, { useState, useEffect } from "react";
import classes from "./Managecurrency.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2 } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import Select from "react-select";
import filter from "../../Assets/filter.png";
import { useUser } from "../../UserContext";
import { Eye, Edit, Trash } from 'lucide-react';
const Managecurrency = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [NewUser, setNewUser] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [currency, setCurrency] = useState("");
  const [currencySearch, setCurrencySearch] = useState("");
  const [showCurrency, setShowCurrency] = useState(false);
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");
  const [reference, setReference] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [bearer, setBearer] = useState('');
  const { user } = useUser();
  const [baseCurrencyCode, setBaseCurrencyCode] = useState('');
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);
  const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(false);
  const [loadingDots, setLoadingDots] = useState(0);

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  const [formData, setFormData] = useState({
    date: "",
    exchange_rate: "",
    currency: "",
  });

  const [editFormData, setEditFormData] = useState({
    date: "",
    currency: "",
    exchange_rate: "",
  });

  const handleChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setEditFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      const { name, value } = eOrName.target;
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = {
        date: formData.date,
        currency: formData.currency, // ✅ Changed from 'id' to 'currency'
        exchange_rate: formData.exchange_rate,
      };

      const body = withCompanyId(payload);
      const response = await api.post(`/v1/exchange-rate/create`, body);

      // Reset form
      setFormData({ date: "", currency: "", exchange_rate: "" });
      setCurrencySearch("");
      setSelectedCurrencyText("");
      setIsModalOpen(false);
      fetchExchangeRates(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Currency Added",
        text: response.data.message || "Currency added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Something went wrong.";

      Swal.fire({
        icon: "error",
        title: "Failed to Add Currency",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };


  const fetchInitialData = async () => {
    try {
      setIsCurrenciesLoading(true);
      const [refRes, currencyRes] = await Promise.all([
        api.get(`/v1/generate-sales-invoice-code`),
        api.get(`/v1/fetch-all-currencies`),
      ]);
      if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (currencyRes?.data?.data) setCurrencies(currencyRes.data.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsCurrenciesLoading(false);
    }
  };

  const fetchCompanyInfo = async () => {
    const token = localStorage.getItem("authToken");
    try {
      setIsCompanyLoading(true);
          const res = await api.get(`/v1/companies/get-info`);
      const item = Array.isArray(res?.data?.data) ? res.data.data[0] : null;
      const code = (item?.currency_base || '').toString().trim().toUpperCase();
      if (code) setBaseCurrencyCode(code);
    } catch (err) {
      console.error("Failed to fetch company info", err);
    } finally {
      setIsCompanyLoading(false);
    }
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setBearer(authToken);
    if (authToken) {
      fetchInitialData();
    }
  }, []);

  // Set user's base currency as default once currencies are loaded (fallback to NGN)
  useEffect(() => {
    if (!currency && Array.isArray(currencies) && currencies.length > 0) {
      const userBaseCode = (baseCurrencyCode || user?.currency_base || user?.base_currency || user?.baseCurrency || user?.currency_code || user?.settings?.base_currency || '').toString().trim().toUpperCase();

      let preferred = null;
      if (userBaseCode) {
        preferred = currencies.find(cur => String(cur.code).toUpperCase() === userBaseCode);
      }

      const ngn = currencies.find(cur =>
        (cur.code && String(cur.code).toUpperCase() === 'NGN') ||
        (cur.symbol && (String(cur.symbol).includes('₦') || String(cur.symbol).toUpperCase() === 'NGN')) ||
        (cur.country && String(cur.country).toLowerCase().includes('nigeria'))
      );

      const chosen = preferred || ngn || null;
      if (chosen) {
        setCurrency(chosen.id);
        setSelectedCurrencyText(`${chosen.symbol} ${chosen.code} - ${chosen.country}`);
        setFormData(prev => ({ ...prev, currency: chosen.id }));
      }
    }
  }, [currencies, currency, user, baseCurrencyCode]);

  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const currencyOptions = currencies.map(cur => ({
    value: cur.id,
    label: `${cur.symbol} ${cur.code} - ${cur.country}`,
    currency: cur
  }));

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      // Use the selected exchange-rate entry id so the specific row is updated
      const payload = {
        date: editFormData.date,
        id: selectedLocation?.id, // exchange-rate record id
        currency: editFormData.currency, // currency id
        exchange_rate: editFormData.exchange_rate,
      };

      const body = withCompanyId(payload);
      const response = await api.post(`/v1/exchange-rate/update`, body);

      setIsNewModalOpen(false);
      setSelectedLocation(null);
      fetchExchangeRates(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Exchange Rate Updated",
        text: response.data.message || "Exchange rate updated successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Failed to update exchange rate.";

      Swal.fire({
        icon: "error",
        title: "Failed to Update Exchange Rate",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const response = await api.get(`/v1/exchange-rate/delete`, { params: { id: selectedLocation.id } });

      setIsDeleteModalOpen(false);
      setSelectedLocation(null);
      fetchExchangeRates(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Exchange Rate Deleted",
        text: response.data.message || "Exchange rate deleted successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete exchange rate.";

      Swal.fire({
        icon: "error",
        title: "Failed to Delete Exchange Rate",
        text: errorMessage,
      });
    } finally {
      setDeleting(false);
    }
  };

  const openEditModal = (exchangeRate) => {
    setSelectedLocation(exchangeRate);
    setEditFormData({
      date: exchangeRate.date || exchangeRate.Date,
      currency: exchangeRate.currency?.id || exchangeRate.Currency?.id || exchangeRate.currency_id || exchangeRate.Currency_id,
      exchange_rate: exchangeRate.exchange_rate || exchangeRate.Exchange_rate,
    });
    setIsNewModalOpen(true);
  };

  const openDeleteModal = (exchangeRate) => {
    setSelectedLocation(exchangeRate);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Authorization token not found.");
      navigate("/signin");
      return;
    }

    fetchStore();
    fetchExchangeRates();
    fetchInitialData();
    fetchCompanyInfo();

  }, [navigate]);

  // Animate pulsating ellipses while loading
  useEffect(() => {
    const anyLoading = isCompanyLoading || isCurrenciesLoading;
    if (!anyLoading) {
      setLoadingDots(0);
      return;
    }
    const id = setInterval(() => {
      setLoadingDots(prev => (prev + 1) % 4);
    }, 350);
    return () => clearInterval(id);
  }, [isCompanyLoading, isCurrenciesLoading]);

  const fetchStore = async () => {
    try {
      const response = await api.get(`/v1/store`);

      if (response.data.status) {
        setStoreOptions(
          response.data.data.map((s) => ({ value: s.id, label: s.store_name }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch stores:", error);
      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    }
  };

  const fetchExchangeRates = async () => {
    try {
      const res = await api.get(`/v1/exchange-rate`);

      setNewUser(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching exchange rates:", err?.response?.data || err.message);
      setError("Failed to fetch exchange rates. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getCurrencyName = (currencyId) => {
    const currency = currencies.find(cur => cur.id == currencyId);
    return currency ? `${currency.symbol} ${currency.code} - ${currency.country}` : currencyId;
  };

  const getStoreName = (storeId) => {
    const store = storeOptions.find(option => option.value === storeId);
    return store ? store.label : storeId;
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.PgeContainerDisp}>
        <div className={classes.actionsbtn_On}>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/transactions/sales-invoice/sale")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button
            className={`${classes.btns_New} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
          <button className={`${classes.btns_News} ${classes.greens}`}>
            Manage Exchange Currency
          </button>
        </div>

        <header className={classes.FrtHeaderOne}>
          <h2 className={classes.FrtTitleOne}>Manage Exchange Currency</h2>
        </header>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search all entries" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Methods</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>
            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.thrdkad}>
            <div className={classes.kad}>
              <p className={classes.kdptg}>Total Currency</p>
              <p className={classes.kdptg1}>{NewUser.length}</p>
            </div>

          </div>
          <button
            className={classes.btnssBtnss}
            onClick={() => setIsModalOpen(true)}
          >
            Add Exchange Rate
          </button>

        </div>
        <div className={classes.headerforActions}>
          <div className={classes.actionsSideRight}>
          </div>

        </div>

        <div className={classes.newUserCont}>
          <table className={classes.newUserTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Date</th>
                <th>Currency</th>
                <th>Exchange Rate</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(5).fill().map((_, i) => (
                      <td key={i}><Skeleton height={20} /></td>
                    ))}
                  </tr>
                ))
              ) : NewUser.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>No Exchange Rates found.</td>
                </tr>
              ) : (
                NewUser.map((rate, index) => (
                  <tr key={rate.id}>
                    <td style={{ width: '50px' }}>{index + 1}</td>
                    <td style={{ width: '100px' }}>{rate.date || rate.Date}</td>
                    <td style={{ width: '100px' }} >
                      {rate.currency
                        ? `${rate.currency.symbol} ${rate.currency.code} - ${rate.currency.country}`
                        : "Unknown"}
                    </td>
                    <td className={classes.movetotheright} style={{ textAlign: 'right', width: '90px' }} >{rate.rate || rate.exchange_rate || rate.Exchange_rate}</td>
                    <td className={classes.actionsCell}>
                      <div className={classes.actionIcons}>
                        <Edit
                          size={16}
                          className={classes.editActionIcon}
                          onClick={() => openEditModal(rate)}
                        />
                        <Trash
                          size={16}
                          className={classes.deleteActionIcon}
                          onClick={() => openDeleteModal(rate)}
                        />
                      </div>
                    </td>


                  </tr>
                ))
              )}
            </tbody>

          </table>

          <div className={classes.paginationContainertxt}>
            <div className={classes.paginationControlstxt}>
              <button>First</button>
              <button className={classes.activation}>1</button>
              <button>Last</button>
              <span className={classes.pageDisplayText}>
                Displaying 1 - {NewUser.length} of {NewUser.length}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Add Currency Modal */}
      {isModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Add Exchange Rate</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className={classes.modalModalBody}>
              <div className={classes.modalFormGroup} style={{marginBottom: '15px'}}>
                    <label>Base Currency</label>
                    <input
                      type="text"
                      name="base_currency"
                      value={(
                        (() => {
                          if (isCompanyLoading) {
                            return `Loading${'.'.repeat(loadingDots)}`;
                          }
                          // Prefer human-readable currency name from login data if available
                          const loginCurrencyName = user?.currency_base && String(user.currency_base).trim() !== '' ? String(user.currency_base) : '';

                          if (loginCurrencyName && isNaN(Number(loginCurrencyName))) {
                            return loginCurrencyName;
                          }

                          // If we have only numeric ID (e.g., from company info), map it to label from currencies list
                          const numericId = (baseCurrencyCode && !isNaN(Number(baseCurrencyCode))) ? String(baseCurrencyCode) : '';
                          if (numericId && Array.isArray(currencies) && currencies.length > 0) {
                            const byId = currencies.find(cur => String(cur.id) === numericId);
                            if (byId) return `${byId.symbol} ${byId.code} - ${byId.country}`;
                          }

                          // Fallback to code-like sources
                          const fallbackPref = user?.base_currency || user?.baseCurrency || user?.currency_code || user?.settings?.base_currency || baseCurrencyCode || 'NGN';
                          return String(fallbackPref).toUpperCase();
                        })()
                      )}
                      disabled
                      style={{ background: '#f5f5f5', color: '#666', cursor: 'not-allowed' }}
                    />
                  </div>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Date</label>
                    <input
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Currency</label>
                    <div
                      className={`${classes["select-container"]} ${showCurrency ? classes.active : ""}`}
                    >
                      <input
                        type="text"
                        placeholder="Search Currency..."
                        value={isCurrenciesLoading ? `Loading${'.'.repeat(loadingDots)}` : (currencySearch || selectedCurrencyText || "")}
                        onClick={() => {
                          if (isCurrenciesLoading) return;
                          setShowCurrency((prev) => !prev);
                          if (!showCurrency) setCurrencySearch("");
                        }}
                        onChange={(e) => {
                          if (isCurrenciesLoading) return;
                          setCurrencySearch(e.target.value);
                          setShowCurrency(true);
                        }}
                        className={classes["select-search"]}
                        required
                        disabled={isCurrenciesLoading}
                      />
                      {showCurrency && !isCurrenciesLoading && (
                        <div className={classes["select-dropdown"]}>
                          {currencies
                            .filter((cur) => {
                              if (!currencySearch) return true;
                              const q = currencySearch.toLowerCase();
                              return (
                                `${cur.id}`.toLowerCase().includes(q) ||
                                `${cur.symbol || ''}`.toLowerCase().includes(q) ||
                                `${cur.code || ''}`.toLowerCase().includes(q) ||
                                `${cur.country || ''}`.toLowerCase().includes(q)
                              );
                            })
                            .map((cur) => (
                              <div
                                key={cur.id}
                                className={classes["select-option"]}
                                onClick={() => {
                                  setCurrency(cur.id);
                                  setSelectedCurrencyText(`${cur.symbol} ${cur.code} - ${cur.country}`);
                                  setCurrencySearch(`${cur.symbol} ${cur.code} - ${cur.country}`);
                                  setShowCurrency(false);

                                  // Update the formData
                                  setFormData((prev) => ({
                                    ...prev,
                                    currency: cur.id,
                                  }));
                                }}
                              >
                                {cur.symbol} {cur.code} - {cur.country}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Exchange Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      name="exchange_rate"
                      placeholder="Enter Exchange Rate"
                      value={formData.exchange_rate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Adding..." : "Add Currency"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Exchange Rate Modal */}
      {isNewModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Edit Exchange Rate</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsNewModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleEditSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Date</label>
                    <input
                      type="date"
                      name="date"
                      value={editFormData.date}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Currency</label>
                    <Select
                      options={currencyOptions}
                      isLoading={currencies.length === 0}
                      placeholder="Select currency"
                      value={
                        currencyOptions.find(
                          (opt) => opt.value === editFormData.currency
                        ) || null
                      }
                      onChange={(option) =>
                        handleEditChange("currency", option.value)
                      }
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Exchange Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      name="exchange_rate"
                      placeholder="Enter Exchange Rate"
                      value={editFormData.exchange_rate}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Updating..." : "Update Exchange Rate"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Exchange Rate Modal */}
      {isDeleteModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalDeleteContent}>
            <div className={classes.modalModalHeader}>
              <h2 style={{ marginBottom: "auto" }}>Delete Exchange Rate</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <div className={classes.modalModalBodyText00}>
              <p>
                Are you sure you want to delete this exchange rate?
                <br />This action cannot be undone.
              </p>
              <div className={classes.modalFormDelFooter}>
                <button
                  className={classes.ModalDeleteBtn0}
                  onClick={handleDelete}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Delete Exchange Rate"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Managecurrency;